// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MqGD0rmQLhXHmfiT0drn {
  max-width: 275px;
  white-space: normal !important;
  height: auto !important;
  line-height: 16px !important;
  /* padding: 8px !important; */
}

.pIWdbqmgMcb1mJJpToB6 {
  text-align: left;
  padding: 6px 10px;
  max-height: 55px;
  box-sizing: border-box !important;
  overflow: hidden;
}

.pIWdbqmgMcb1mJJpToB6 svg {
  color: #0000008a !important;
}

.XoIAAJaXcMuOaC1fMcSw {
  float: right;

  svg {
    color: currentColor !important;
  }
}

.ediKpN3cryHw8j2DFgwo {
  display: flex;
  justify-content: space-between;
}

.OrlAd0ZEFnSPbYL3yiRg {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65) !important;
  text-transform: uppercase;
  padding-right: 5px;
}

.sanVq71Ls27x7MbTP8S_ {
  justify-content: flex-end;
}

.vCjuwHKlgXDQtJ_F64Ya {
  justify-content: flex-start;
}

.vCjuwHKlgXDQtJ_F64Ya svg {
  margin-right: 3px;
  margin-top: -1px;
}

.trk_NBIG21_xA_55Ipwj {
  display: flex;
}

.trk_NBIG21_xA_55Ipwj div {
  flex: 1;
  display: flex;
  align-items: center;
}

.TFfFrs5py07IV1Mqyx47 {
  min-width: 18px;
  width: 18px;
  height: 18px;
  font-size: 18px !important;
}

.TFfFrs5py07IV1Mqyx47.E1eWeFLxZkpNbq2mQzem {
  font-size: 18px !important;
  color: rgba(0, 0, 0, 0.2) !important;
}

.TFfFrs5py07IV1Mqyx47.l9XQDey2WDtyUC7Sow9g {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.4) !important;
}

.Y_FMFkCNVphXOcW_aX4a {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4) !important;
  font-style: italic;
}

.jK3PeOPXL3S31OuCLJ4g {
  flex: 1;
}

.lqd_HuCTiaTTYgzQ1PBD {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./datasets/handsontable/submission-table/renderer/header/header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;;EAEZ;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".submission-table-header-description-tooltip {\n  max-width: 275px;\n  white-space: normal !important;\n  height: auto !important;\n  line-height: 16px !important;\n  /* padding: 8px !important; */\n}\n\n.columnHeader {\n  text-align: left;\n  padding: 6px 10px;\n  max-height: 55px;\n  box-sizing: border-box !important;\n  overflow: hidden;\n}\n\n.columnHeader svg {\n  color: #0000008a !important;\n}\n\n.find-and-replace {\n  float: right;\n\n  svg {\n    color: currentColor !important;\n  }\n}\n\n.flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n.row-1 {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.65) !important;\n  text-transform: uppercase;\n  padding-right: 5px;\n}\n\n.extras {\n  justify-content: flex-end;\n}\n\n.icon-container {\n  justify-content: flex-start;\n}\n\n.icon-container svg {\n  margin-right: 3px;\n  margin-top: -1px;\n}\n\n.row-2 {\n  display: flex;\n}\n\n.row-2 div {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.icon-override {\n  min-width: 18px;\n  width: 18px;\n  height: 18px;\n  font-size: 18px !important;\n}\n\n.icon-override.icon-info {\n  font-size: 18px !important;\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.icon-override.icon-lock {\n  font-size: 16px !important;\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n\n.icon-text {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.4) !important;\n  font-style: italic;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.required-indicator {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submission-table-header-description-tooltip": `MqGD0rmQLhXHmfiT0drn`,
	"columnHeader": `pIWdbqmgMcb1mJJpToB6`,
	"find-and-replace": `XoIAAJaXcMuOaC1fMcSw`,
	"flex": `ediKpN3cryHw8j2DFgwo`,
	"row-1": `OrlAd0ZEFnSPbYL3yiRg`,
	"extras": `sanVq71Ls27x7MbTP8S_`,
	"icon-container": `vCjuwHKlgXDQtJ_F64Ya`,
	"row-2": `trk_NBIG21_xA_55Ipwj`,
	"icon-override": `TFfFrs5py07IV1Mqyx47`,
	"icon-info": `E1eWeFLxZkpNbq2mQzem`,
	"icon-lock": `l9XQDey2WDtyUC7Sow9g`,
	"icon-text": `Y_FMFkCNVphXOcW_aX4a`,
	"spacer": `jK3PeOPXL3S31OuCLJ4g`,
	"required-indicator": `lqd_HuCTiaTTYgzQ1PBD`
};
export default ___CSS_LOADER_EXPORT___;
